import { Component, OnInit, OnDestroy } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

// other libraries;
import { LangChangeEvent } from "@ngx-translate/core";


// services
import { CredentialService } from "../../../../services/credential.service";

// models
import { ParticipantCredential } from "../../../../models/participant-credential";

// extends
import { BasePage } from "../../../base";

@Component({
    selector: 'app-credential',
    templateUrl: './credential.page.html',
    styleUrls: ['./credential.page.scss'],
})
export class CredentialPage extends BasePage implements OnInit {

    public credential: ParticipantCredential;

    public loading: boolean = true;

    /**
     * Slider options
     *
     * @type {SliderOptions}
     */
    slideOpts = {
        initialSlide: 0,
    };

    constructor(
        private metaService: Meta,
        private titleService: Title,
        public route: ActivatedRoute,
        public credentialService: CredentialService
    ) {
        super();

        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.userLang = event.lang;
            // refresh data with translation
            this.ngOnInit();
        });
    }

    ngOnInit() {
        // load credential, by token, which is id + '-' + token
        const token = decodeURIComponent(this.route.snapshot.params['id']);

        if (!!token) {

            this.credentialService.getById(token).subscribe(
                (credential: any) => {

                    this.credential = credential;

                    let image = credential.certification_preview ? credential.certification_preview : credential.certification_badge;

                    // this.metaService.updateTag({ property: 'og:image', content: image }, "property='og:image'");
                    // this.metaService.updateTag({ property: 'og:image:secure_url', content: image }, "property='og:image:secure_url'");
                    // this.metaService.updateTag({ name: 'twitter:image', content: image }, "name='twitter:image'");
                    //
                    // this.metaService.updateTag({ property: 'og:image:alt', content: credential.certification_name }, "property='og:image:alt'");
                    // this.metaService.updateTag({ name: 'twitter:image:alt', content: credential.certification_name }, "name='twitter:image:alt'");
                    //
                    // this.metaService.updateTag({ property: 'og:title', content: credential.certification_name }, "property='og:title'");
                    // this.metaService.updateTag({ name: 'twitter:title', content: credential.certification_name }, "name='twitter:title'");
                    //
                    // this.metaService.updateTag({ property: 'og:description', content: this.translate.instant('CREDENTIAL_WALLET_SHARE_TEXT') }, "property='og:description'");
                    // this.metaService.updateTag({ name: 'twitter:description', content: this.translate.instant('CREDENTIAL_WALLET_SHARE_TEXT') }, "name='twitter:description'");
                    //
                    // this.metaService.updateTag({ property: 'og:url', content: location.href }, "property='og:url'");

                    this.loading = false;
                }, (error) => {
                    this.loading = false;
                    const data = error.error;
                    this.overlayService.showError(data.message);
                    // redirect to login
                    this.router.navigate(['login']);
                });
        } else {
            // redirect to login in case of not existing params
        }
    }

}
